import React from 'react';
import { TDR } from 'tdr-common';
import CTALink from '../../buttons/CTALink';
import { useTranslation } from 'react-i18next';

export const GetHelp = ({ bookingId }: { bookingId: string }) => {
	const href = `mailto:${TDR.SUPPORT_EMAIL}?subject=Need help with booking id: ${bookingId}`;
	const { t } = useTranslation();
	return <CTALink text={t('actions.get_help')} to={href} variant='dark' />;
};